import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestVeiculos({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'veiculos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteVeiculo({ payload }) {
  try {
    const { idveiculo, params } = payload;

    yield call(api.delete, `veiculos/${idveiculo}`);
    yield put(successRemove({ ...params, pesquisalista: false }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(t(e)));
    else toast.error(t(erros));
  }
}

export function* store({ payload }) {
  try {
    const { veiculo, params } = payload;

    yield call(api.post, 'veiculos', veiculo);
    yield put(successRemove({ ...params, pesquisalista: false }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/veiculos');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { idveiculo } = payload;

    const { data } = yield call(api.get, `veiculos/combustivel/${idveiculo}`); // A tela de cadastro de veiculo só aceita o tipo combustível nela!
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { veiculo, params } = payload;

    yield call(api.put, 'veiculos', veiculo);
    yield put(successRemove({ ...params, pesquisalista: false }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/veiculos');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'veiculos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest('@veiculo/VEICULOS_IN_REQUEST', requestVeiculos),
  takeLatest('@veiculo/DELETE_VEICULO', deleteVeiculo),
  takeLatest('@veiculo/SUCCESS_REMOVE', requestVeiculos),
  takeLatest('@veiculo/STORE_VEICULO', store),
  takeLatest('@veiculo/FIND_VEICULO', find),
  takeLatest('@veiculo/UPDATE_VEICULO', update),
  takeLatest('@veiculo/RECORD_FILTERING', applyedFilters),
]);
